export default __webpack_public_path__ + "static/media/AnaFernándezRuizEnglishactualizado.1d3b6e06.pdf";